import urlApi from '../../../actions/urlApi';
import { useEffect, useState } from 'react';
export var useGetVideoData = function (link) {
    var _a = useState({
        img: '',
        name: '',
        id: '',
        height: 100
    }), videoData = _a[0], setVideoData = _a[1];
    useEffect(function () {
        var myregexp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var parsedLink = link === null || link === void 0 ? void 0 : link.match(myregexp);
        if (parsedLink === null)
            return;
        urlApi()
            .getYoutubeVideo(parsedLink[7])
            .then(function (res) {
            var thumbnails = res.data.items[0].snippet.thumbnails;
            var url = '';
            var videoHeight = 100;
            var videoWidth = 100;
            if (thumbnails.maxres) {
                url = thumbnails.maxres.url;
                videoHeight = thumbnails.maxres.height;
                videoWidth = thumbnails.maxres.width;
            }
            else if (thumbnails.standard) {
                url = thumbnails.standard.url;
                videoHeight = thumbnails.standard.height;
                videoWidth = thumbnails.standard.width;
            }
            else {
                url = thumbnails.high.url;
                videoHeight = thumbnails.high.height;
                videoWidth = thumbnails.high.width;
            }
            setVideoData({
                img: url,
                name: res.data.items[0].snippet.title,
                id: res.data.items[0].id,
                height: videoHeight - 80,
                width: videoWidth
            });
        });
    }, [link]);
    return videoData;
};
//# sourceMappingURL=useGetVideoData.js.mapimport urlApi from '../../../actions/urlApi';
import { useEffect, useState } from 'react';
export var useGetVideoData = function (link) {
    var _a = useState({
        img: '',
        name: '',
        id: '',
        height: 100
    }), videoData = _a[0], setVideoData = _a[1];
    useEffect(function () {
        var myregexp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var parsedLink = link === null || link === void 0 ? void 0 : link.match(myregexp);
        if (parsedLink === null)
            return;
        urlApi()
            .getYoutubeVideo(parsedLink[7])
            .then(function (res) {
            var thumbnails = res.data.items[0].snippet.thumbnails;
            var url = '';
            var videoHeight = 100;
            var videoWidth = 100;
            if (thumbnails.maxres) {
                url = thumbnails.maxres.url;
                videoHeight = thumbnails.maxres.height;
                videoWidth = thumbnails.maxres.width;
            }
            else if (thumbnails.standard) {
                url = thumbnails.standard.url;
                videoHeight = thumbnails.standard.height;
                videoWidth = thumbnails.standard.width;
            }
            else {
                url = thumbnails.high.url;
                videoHeight = thumbnails.high.height;
                videoWidth = thumbnails.high.width;
            }
            setVideoData({
                img: url,
                name: res.data.items[0].snippet.title,
                id: res.data.items[0].id,
                height: videoHeight - 80,
                width: videoWidth
            });
        });
    }, [link]);
    return videoData;
};
//# sourceMappingURL=useGetVideoData.js.map